import { render } from "./ListUsers.vue?vue&type=template&id=db454658"
import script from "./ListUsers.vue?vue&type=script&lang=js"
export * from "./ListUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__